import React, { useEffect, useState, useRef } from "react";
import "./HomeRightFloatIcons.css";
import { useMsal } from "@azure/msal-react";
import { NavLink } from "react-router-dom";

function HomeRightFloatIcons() {
  // const [isDropdownOpen, setDropdownOpen] = useState(false);
  // const genAIToolsRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsers = [
    "arpita.m.singh",
    "varsha.a.tyagi",
    "h.srinivasan",
    "aluru.akash",
    "aayushi.bharti",
    "ankur.e.mishra",
    "uma.rani.battu",
    "srikanth.narabathoju",
    "reshmi.haridas.m",
    "jeevadharani.ramanan",
    "kusume.sridhar",
    "potnuru.sandeep",
  ];
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const adminRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (adminRef.current && !adminRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Close dropdown when focus moves outside the container
  // useEffect(() => {
  //   const handleFocusOut = (e) => {
  //     if (
  //       genAIToolsRef.current &&
  //       !genAIToolsRef.current.contains(e.relatedTarget)
  //     ) {
  //       setDropdownOpen(false);
  //     }
  //   };
  //   const node = genAIToolsRef.current;
  //   if (node) {
  //     node.addEventListener("focusout", handleFocusOut);
  //   }
  //   return () => {
  //     if (node) {
  //       node.removeEventListener("focusout", handleFocusOut);
  //     }
  //   };
  // }, []);
  return (
    <>
      <div className="float-wrap">
        <div className="floatIcon-innerWrap float-admin-icon-wrap">
          <div className="rightsidebar-wrap">
            <div className="rightsidebar-row admin-right-box">
              {allowedUsers.includes(loggedInEnterpriseId) && (
              <div
                className="sideimg-box admin-dropdown-container"
                ref={adminRef}
                onMouseEnter={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
                onClick={() => setDropdownOpen((prev) => !prev)}
              >
                <div className="admin-box">
                  <div className="admin-icon-wrapper">
                    <img
                      src="images/Sidebar/new-icons/admin-icon.png"
                      alt="Admin"
                      className="white-icon rightside-feedback-icon"
                    />
                    <img
                      src="images/Sidebar/new-icons/admin-icon-hover.png"
                      alt="Admin Hover"
                      className="grey-icon rightside-feedback-icon-hover"
                    />
                    <p className="feedback-word">Admin</p>
                  </div>

                  {isDropdownOpen && (
                    <div className="admin-dropdown">
                      <NavLink to="/Admin-Analytics" className="dropdown-item">
                        Analytics
                      </NavLink>
                      <NavLink to="/Reviews" className="dropdown-item">
                        Feedback
                      </NavLink>
                    </div>
                  )}
                </div>
              </div>
            )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="float-wrap">
        <div className="floatIcon-innerWrap float-gen-compass-icon-wrap">
          <div className="rightsidebar-wrap">
            <div className="rightsidebar-row">
              <div className="sideimg-box gentools">
                <a
                  href="https://atc.l-tt.accenture.com/GenAI-Tools"
                  aria-label="gen-icon"
                  target="_blank"
                >
                  <img
                    src="images/Sidebar/GenAI-Tools-hover.png"
                    alt="logo"
                    className="white-icon rightside-feedback-icon"
                  />
                  <img
                    src="images/Sidebar/GenAI-Tools.png"
                    alt="logo"
                    className="grey-icon rightside-feedback-icon-hover"
                  />
                  <p className="feedback-word">GenAI Tools</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default HomeRightFloatIcons;
